import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { EqTaretcostingCalcPopupComponent } from '../eq-taretcosting-calc-popup/eq-taretcosting-calc-popup.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-edit-eq-calc',
  templateUrl: './edit-eq-calc.component.html',
  styleUrls: ['./edit-eq-calc.component.css']
})
export class EditEqCalcComponent implements ICellRendererAngularComp {
  public gridApi: any;
  public params: any;
  isEditVisible: any;
  countryCode;
  totalBK: any;
  crp: any;
  margin: any;
  bk: any;
  scenario: any;

  @Output() opened = new EventEmitter<void>();


  constructor(
    public dialog: MatDialog,
    private localStorageService: LocalStorageService,
  ) { }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  // get called on load of the component;
  agInit(params: ICellRendererParams) {
    this.params = params;
    this.gridApi = params.api;

    this.countryCode = this.localStorageService.get('countryCode');

    if (!this.params.node.group && this.params.data.Name == "CRP") {
      this.isEditVisible = this.params.data.IsEditable;
    } else {
      this.isEditVisible = false;
    }
  }

  editData(params: any) {
    if (!this.params.node.group && this.params.column.colId == "tc") {
      this.scenario = this.gridApi.getRowNode(0).data.TargetScenario.TargetCost.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.TargetScenario.TargetCost.PerSystem
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.TargetScenario.TargetCost.PerSystem
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.TargetScenario.TargetCost.PerSystem
      this.totalBK = this.gridApi.getDisplayedRowAtIndex(7).data.TargetScenario.TargetCost.PerSystem
    }
    if (!this.params.node.group && this.params.column.colId == "fc") {
      this.scenario = this.gridApi.getRowNode(0).data.TargetScenario.Forecast.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.TargetScenario.Forecast.PerSystem;
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.TargetScenario.Forecast.PerSystem;
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.TargetScenario.Forecast.PerSystem;
      this.totalBK = this.gridApi.getDisplayedRowAtIndex(7).data.TargetScenario.Forecast.PerSystem;
    }

    if (!this.params.node.group && this.params.column.colId == "tcOptA") {
      this.scenario = this.gridApi.getRowNode(0).data.OptionA.TargetCost.PerSystem
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionA.TargetCost.PerSystem
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionA.TargetCost.PerSystem
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionA.TargetCost.PerSystem
      this.totalBK = this.gridApi.getDisplayedRowAtIndex(7).data.OptionA.TargetCost.PerSystem
    }
    if (!this.params.node.group && this.params.column.colId == "fcOptA") {
      this.scenario = this.gridApi.getRowNode(0).data.OptionA.Forecast.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionA.Forecast.PerSystem;
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionA.Forecast.PerSystem;
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionA.Forecast.PerSystem;
      this.totalBK = this.gridApi.getDisplayedRowAtIndex(7).data.OptionA.Forecast.PerSystem;
    }

    if (!this.params.node.group && this.params.column.colId == "tcOptB") {
      this.scenario = this.gridApi.getRowNode(0).data.OptionB.TargetCost.PerSystem
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionB.TargetCost.PerSystem
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionB.TargetCost.PerSystem
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionB.TargetCost.PerSystem
      this.totalBK = this.gridApi.getDisplayedRowAtIndex(7).data.OptionB.TargetCost.PerSystem
    }
    if (!this.params.node.group && this.params.column.colId == "fcOptB") {
      this.scenario = this.gridApi.getRowNode(0).data.OptionB.Forecast.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionB.Forecast.PerSystem;
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionB.Forecast.PerSystem;
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionB.Forecast.PerSystem;
      this.totalBK = this.gridApi.getDisplayedRowAtIndex(7).data.OptionB.Forecast.PerSystem;
    }

    if (!this.params.node.group && this.params.column.colId == "tcOptC") {
      this.scenario = this.gridApi.getRowNode(0).data.OptionC.TargetCost.PerSystem
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionC.TargetCost.PerSystem
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionC.TargetCost.PerSystem
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionC.TargetCost.PerSystem
      this.totalBK = this.gridApi.getDisplayedRowAtIndex(7).data.OptionC.TargetCost.PerSystem
    }
    if (!this.params.node.group && this.params.column.colId == "fcOptC") {
      this.scenario = this.gridApi.getRowNode(0).data.OptionC.Forecast.PerSystem;
      this.crp = this.gridApi.getDisplayedRowAtIndex(0).data.OptionC.Forecast.PerSystem;
      this.margin = this.gridApi.getDisplayedRowAtIndex(1).data.OptionC.Forecast.PerSystem;
      this.bk = this.gridApi.getDisplayedRowAtIndex(2).data.OptionC.Forecast.PerSystem;
      this.totalBK = this.gridApi.getDisplayedRowAtIndex(7).data.OptionC.Forecast.PerSystem;
    }

    let dialogRef = this.dialog.open(EqTaretcostingCalcPopupComponent, {
      height: '40%',
      width: '60%',
      panelClass: 'kmat-dialog-container',
      data: {
        scenario: this.scenario,
        crp: this.crp,
        margin: this.margin,
        bk: this.bk,
        totalBK: this.totalBK
      }
    })

    if (this.params.onOpened) {
      this.params.onOpened();
    }

    dialogRef.afterClosed().subscribe(result => {
      if (result != "" && result != null) {
        if (!this.params.node.group && this.params.column.colId == "tc") {
          this.gridApi.getRowNode(0).data.TargetScenario.TargetCost.PerSystem = result.Scenario
          this.gridApi.getDisplayedRowAtIndex(0).data.TargetScenario.TargetCost.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.TargetScenario.TargetCost.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.TargetScenario.TargetCost.PerSystem = result.BK;
        }
        if (!this.params.node.group && this.params.column.colId == "fc") {
          this.gridApi.getRowNode(0).data.TargetScenario.Forecast.PerSystem = result.Scenario;
          this.gridApi.getDisplayedRowAtIndex(0).data.TargetScenario.Forecast.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.TargetScenario.Forecast.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.TargetScenario.Forecast.PerSystem = result.BK;
        }

        if (!this.params.node.group && this.params.column.colId == "tcOptA") {
          this.gridApi.getRowNode(0).data.OptionA.TargetCost.PerSystem = result.Scenario;
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionA.TargetCost.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionA.TargetCost.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionA.TargetCost.PerSystem = result.BK;
        }
        if (!this.params.node.group && this.params.column.colId == "fcOptA") {
          this.gridApi.getRowNode(0).data.OptionA.Forecast.PerSystem = result.Scenario;
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionA.Forecast.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionA.Forecast.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionA.Forecast.PerSystem = result.BK;
        }

        if (!this.params.node.group && this.params.column.colId == "tcOptB") {
          this.gridApi.getRowNode(0).data.OptionB.TargetCost.PerSystem = result.Scenario;
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionB.TargetCost.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionB.TargetCost.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionB.TargetCost.PerSystem = result.BK;
        }
        if (!this.params.node.group && this.params.column.colId == "fcOptB") {
          this.gridApi.getRowNode(0).data.OptionB.Forecast.PerSystem = result.Scenario;
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionB.Forecast.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionB.Forecast.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionB.Forecast.PerSystem = result.BK;
        }

        if (!this.params.node.group && this.params.column.colId == "tcOptC") {
          this.gridApi.getRowNode(0).data.OptionC.TargetCost.PerSystem = result.Scenario;
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionC.TargetCost.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionC.TargetCost.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionC.TargetCost.PerSystem = result.BK;
        }
        if (!this.params.node.group && this.params.column.colId == "fcOptC") {
          this.gridApi.getRowNode(0).data.OptionC.Forecast.PerSystem = result.Scenario;
          this.gridApi.getDisplayedRowAtIndex(0).data.OptionC.Forecast.PerSystem = result.CRP;
          this.gridApi.getDisplayedRowAtIndex(1).data.OptionC.Forecast.PerSystem = result.Margin;
          this.gridApi.getDisplayedRowAtIndex(2).data.OptionC.Forecast.PerSystem = result.BK;
        }
        this.gridApi.refreshCells({ force: true });
        this.gridApi.redrawRows();
      }
    });
  }

}
